/** Muted caption telling someone where to run a test this server cannot run itself. */
const RunHint = ({ hint }: { hint: string }) => (
  <p className="text-xs text-muted-foreground">{hint}</p>
);

export default RunHint;
